import { ChannelMetric } from 'lib-dashboard-types';
import { Channel, Media } from 'lib-shared-types-channels';
import { createContext, useContext } from 'react';

export type ChannelDashboardChannelContextValue = {
  /** The channel media type. */
  readonly media: Media;
  /** The list of channels belonging to the media type. */
  readonly channels: readonly Channel[];
  /** The metrics for the current channel media. */
  readonly metrics?: ChannelMetric;
  /** Whether to show the skeleton UI, e.g. when loading. */
  readonly isSkeleton: boolean;
};

export const ChannelDashboardChannelContext =
  createContext<ChannelDashboardChannelContextValue>(undefined!);

export const useChannelDashboardChannelContext =
  (): ChannelDashboardChannelContextValue => {
    return useContext(ChannelDashboardChannelContext);
  };
